import { Injectable } from '@angular/core';
import { serviceVersion, serviceApiRoots } from './../../config/config/config.constants';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './../../config/config/config.service';
import { SpinnerService} from './../spinner/spinner.service';
import {map} from 'rxjs/internal/operators';
import {UtilityCookieService as utilityCookie} from '../../utils/cookie/utilitycookie.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private config: ConfigService,
              private http: HttpClient) { }

  getServiceUrl(serviceName: string): string {
    let rootUrl;

    if (this.config.get('useJson')) {
      // console.log('useJson', serviceName)
      // if (serviceName === 'getOrderDetails') {
      //   if (localStorage.approved) {
      //     serviceName = serviceName + '-approved';
      //   }
      //
      // }
      rootUrl = this.config.get('apiRoot') + serviceName + '.json';
    } else {
      rootUrl = serviceApiRoots.get(serviceName) ? serviceApiRoots.get(serviceName) : this.config.get('apiRoot');
      const isGetRxHistoryCookie: boolean = (utilityCookie.getCookie('getRxHistoryUpdated') === 'on');
      if (serviceName === 'getRxHistory') {
        rootUrl = rootUrl + (isGetRxHistoryCookie ? '1.2.0/' : '1.1.0/') + serviceName;
      } else if (serviceName !== 'RxAuthChallenge' && serviceName !== 'SubmitRxChallenge' && serviceName !== 'webContent') {
        rootUrl = rootUrl + serviceName;
      }
    }
    return rootUrl;
  }

  getVersion(serviceName: string): string {
    const version = serviceVersion.get(serviceName) ? serviceVersion.get(serviceName) : this.config.get('version');
    return version;
  }

  getDefaultQueryParams(serviceName: string, opName: string, modifyParams: boolean) {
    const req = {};
    req['version'] = this.getVersion(serviceName);
    req['appName'] = modifyParams ? 'ICE_WEB' : this.config.getAppName();
    req['serviceName'] = serviceName;
    req['operationName'] = opName;
    req['deviceType'] = modifyParams ? 'DESKTOP' : this.config.getDeviceType();
    req['channelName'] = modifyParams ? 'WEB' : this.config.get('channelName');
    req['lineOfBusiness'] = this.config.get('lineOfBusiness');
    req['deviceToken'] = this.config.get('deviceToken');
    req['xmlFormat'] = this.config.get('xmlFormat');
    // req['source'] = modifyParams ? 'ICE_WEB' : this.config.getSource();
    req['apiKey'] = this.config.get('apiKey');
    req['apiSecret'] = this.config.get('apiSecret');
    if (serviceName === 'getPatientDemography' || serviceName === 'getRxHistory') {
        req['type'] = 'inode';
    }
    if (serviceName === 'IntegratedCustomerExpService') {
        req['responseFormat'] = 'XML';
        req['securityType'] = 'apiKey';
    }
    if (modifyParams || serviceName === 'getPaymentProfile' || serviceName === 'addPaymentCard' || serviceName === 'addProfile') {
        req['responseFormat'] = 'JSON';
        req['securityType'] = 'apiKey';
        if (serviceName === 'getPaymentProfile') {
          req['type'] = 'retlegget';
        }
        if (serviceName === 'addPaymentCard' || serviceName === 'addProfile') {
          req['type'] = 'retleg';
        }
    }
    if (serviceName === 'ProfileService') {}
    if (opName === 'webContent') {
      req['apiSecret'] = this.config.get('servicesApiSecret');
      req['apiKey'] = this.config.get('servicesApiKey');
      req['appName'] = 'CVS_WEB';
      req['lineOfBusiness'] = 'RETAIL';
      req['channelName'] = 'MOBILE';
      req['version'] = '2.0';
      delete req['source'];
    }
    if (serviceName === 'refreshToken') {}
    if (serviceName === 'prefetchRxStatusSummary') {
      req['source'] = 'MDP_WEB';
      req['appName'] = 'MDP_WEB';
      req['apiKey'] = this.config.get('mdp');
      req['responseFormat'] = 'JSON';
      req['release'] = 'JULY';
    }

    return req;
  }
  post(serviceName: string, queryParams: any, request: any, headersObj?: any): any {
    let url = this.getServiceUrl(serviceName);
    if (queryParams !== null && Object.keys(queryParams).length !== 0) {
      url = url + '?' + this.getQueryString(queryParams);
    }

    let post: any;
    if (headersObj) {
      const httpOptions = {
        headers: headersObj
      };
      post = this.http.post(url, request, httpOptions);
    } else {
      post = this.http.post(url, request);
    }
    return post;
  }

  getJsonp(queryParams: any): any {
    const QueryParams = queryParams;
    return this.http.jsonp(QueryParams, 'callback');
  }

  get(serviceName: string, params: any, headers?: any): any {
    const options: any = {};
    if (headers) {
      options.headers = headers;
    }
    let url = this.getServiceUrl(serviceName);
    if (params !== null && Object.keys(params).length !== 0) {
      url = url + '?' + this.getQueryString(params);
    }
    return this.http.get(url, options);
  }

  getQueryString(queryParams) {
    let ret = '';
    if (queryParams) {
      for (const key of Object.keys(queryParams)) {
        ret += key + '=' + queryParams[key] + '&';
      }
      if (ret.length > 0) {
        ret = ret.substring(0, (ret.length - 1));
      }
    }
    return ret;
  }
}
